Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNativeContainerStyles = void 0;
var _props = require("../../props");
var _useSharedStyles2 = require("./useSharedStyles");
var _styles = require("../../../../styles");
var useNativeContainerStyles = exports.useNativeContainerStyles = function useNativeContainerStyles(_ref) {
  var _sharedStyles;
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? _props.ButtonSize.normal : _ref$size;
  var _useSharedStyles = (0, _useSharedStyles2.useSharedStyles)(),
    sharedStyles = _useSharedStyles.sharedStyles;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    boxShadows = _STYLES$useStyles.boxShadows;
  var nativeContainerStyles = Object.assign({
    borderRadius: sharedStyles == null ? void 0 : (_sharedStyles = sharedStyles["label_".concat(size)]) == null ? void 0 : _sharedStyles.borderRadius,
    backgroundColor: COLORS.white
  }, boxShadows.button.ios);
  return {
    nativeContainerStyles: nativeContainerStyles
  };
};